import type { FC } from "react";
import { TbChevronLeft, TbChevronRight } from "react-icons/tb";
import { Button } from "./Button";
import styles from "./Pagination.module.css";

interface PaginationProps {
  pageIndex: number;
  pageCount: number;
  canPreviousPage: boolean;
  canNextPage: boolean;
  onPreviousPage: () => void;
  onNextPage: () => void;
}

export const Pagination: FC<PaginationProps> = ({
  pageIndex,
  pageCount,
  canPreviousPage,
  canNextPage,
  onPreviousPage,
  onNextPage,
}) => {
  return (
    <div className={styles.pagination}>
      <Button
        size="sm"
        variant="ghost"
        icon={TbChevronLeft}
        onClick={onPreviousPage}
        disabled={!canPreviousPage}
        aria-label="Previous page"
      />
      <span className={styles.pageInfo}>
        Page {pageIndex + 1} of {pageCount}
      </span>
      <Button
        size="sm"
        variant="ghost"
        icon={TbChevronRight}
        onClick={onNextPage}
        disabled={!canNextPage}
        aria-label="Next page"
      />
    </div>
  );
};
